import axios from './axios-instance'

export default {
  getAll (payload) {
    return axios.get('v1/admin/users', { params: payload })
  },
  get (id) {
    return axios.get(`v1/admin/users/${id}`)
  },
  getSpreadSheetWithAll (search = '', isActive = 'all', startDate = null, endDate = null) {
    return axios.get('v1/admin/users', {
      params: { q: search, active: isActive, start_date: startDate, end_date: endDate },
      responseType: 'arraybuffer',
      headers: {
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }
    })
  }
}
